import { z } from 'zod';

const nonNegativeNumber = (requiredMessage: string) =>
  z
    .number({
      required_error: requiredMessage,
      invalid_type_error: 'Bitte eine gueltige Zahl eingeben',
    })
    .min(15, 'Mindestens 15 Min.');

export const appointmentFormSchema = z.object({
  files: z.array(z.any(), {
    invalid_type_error: 'Dateien muessen als Liste uebergeben werden',
  }).optional(),
  nettoarbeitszeit: nonNegativeNumber('Nettoarbeitszeit ist erforderlich'),
  anfahrt: nonNegativeNumber('Anfahrt ist erforderlich'),
  entfernung: nonNegativeNumber('Abfahrt ist erforderlich'),
});

export type AppointmentFormValues = z.infer<typeof appointmentFormSchema>;
